<template>
  <v-row>
    <v-col style="display: flex" cols="12" md="12">
      <h2>{{ $t(title) }}</h2>
      <v-icon dense class="table-action mx-1" @click="changeShow()">
        {{ showCard ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ExpandForm',
  components: {},
  props: {
    title: String,
    showCards: Object,
    name: String,
  },
  computed: {
    showCard() {
      if (this.showCards[this.name] == undefined) {
        this.$set(this.showCards, this.name, true)
      }
      return this.showCards[this.name]
    },
  },
  methods: {
    changeShow() {
      this.showCards[this.name] = !this.showCards[this.name]
    },
  },
}
</script>